<template>
    <div
        class="card-overlay absolute top-0 left-0 bottom-0 right-0 w-full h-full bg-white/[0.85] dark:bg-slate-800/[0.85] backdrop-blur-sm z-20 flex justify-center items-center p-5"
        :class="{ 'flex-col': !card.topCard, 'flex-row': card.topCard }"
        v-if="!dismissed"
    >
        <div
            class="text-center"
            :class="{ 'mb-6': !card.topCard, 'p-4': card.topCard }"
        >
            <i class="fas fa-info-circle text-orange fa-2x mb-5"></i>
            <p class="text-gray-800 dark:text-gray-100">You're likely ineligible for the</p>
            <p class="text-gray-800 dark:text-gray-100 font-bold text-lg mb-5">{{ card.title }}</p>

            <div class="flex flex-col space-y-2 sm:flex-row sm:space-y-0 sm:space-x-3 justify-center">
                <button
                    type="button"
                    id="hs-card-exclusion-see-why"@click.prevent="openExclusionsSidebar"
                    class="rounded-md bg-white dark:bg-slate-700 py-2.5 px-3.5 text-sm font-semibold text-gray-900 dark:text-gray-100 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-slate-600 hover:bg-gray-50 dark:hover:bg-slate-600"
                >
                    See Why <i class="fa-light fa-arrow-right ml-2"></i>
                </button>
                <button
                    v-if="hasViewedReasons"
                    type="button"
                    @click.prevent="dismissCard"
                    class="rounded-md bg-white dark:bg-slate-700 py-2.5 px-3.5 text-sm font-semibold text-gray-900 dark:text-gray-100 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-slate-600 hover:bg-gray-50 dark:hover:bg-slate-600"
                >
                    I Understand
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from "pinia";
import { useNextCardStore } from "@/store/nextcard";
import { useDashboardStore } from "@/store/dashboard";

export default {
    name: "CardExclusion",
    props: {
        card: Object,
        offenders: {
            type: Object,
            default: {},
        },
    },
    data: () => ({
        dismissed: false,
        hasViewedReasons: false
    }),
    computed: {
        ...mapState(useNextCardStore, [
            "showExclusionsSidebar",
            "activeNextCard",
        ]),
        ...mapState(useDashboardStore, [
            "user"
        ]),
        cdnUrl() {
            return window.cdnUrl;
        }
    },
    methods: {
        ...mapActions(useNextCardStore, [
            "setActiveNextCard",
            "setExclusionsSidebar",
        ]),
        ...mapActions(useDashboardStore, [
            "getUsers"
        ]),
        openExclusionsSidebar() {
            const cardCopy = { ...this.card };

            if (cardCopy.card_image && cardCopy.card_image.path && cardCopy.card_image.file_name) {
                cardCopy.image = `${this.cdnUrl}/${cardCopy.card_image.path}/_small/${cardCopy.card_image.file_name}`;
            }

            this.hasViewedReasons = true;

            this.setActiveNextCard({
                card: cardCopy,
                offenders: this.offenders,
            });
            this.setExclusionsSidebar(true);
        },
        closeExclusionsSidebar() {
            this.setExclusionsSidebar(false);
        },
        dismissCard() {
            this.dismissed = true;
            this.closeExclusionsSidebar();
            this.$emit('hide-card');
        }
    },
    mounted() {
        this.getUsers();
    },
};
</script>
